<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix modal-heading">
      <span>Edit {{ existing.name }}</span>
      <el-button type="text" @click="$modal.hide('collection-edit-form')">
        <font-awesome-icon icon="window-close" fixed-width></font-awesome-icon>
      </el-button>
    </div>
    <el-form
      @submit.native.prevent="update"
      label-position="right"
      label-width="100px"
    >
      <el-row v-if="existing.default" style="margin-bottom: 1rem">
        <el-alert
          title="Default Collection!"
          type="warning"
          :description="defaultCollectionWarning"
          show-icon
          :closable="false"
        ></el-alert>
      </el-row>

      <el-form-item
        :error="form.errors.first('name') ? form.errors.first('name') : null"
        label="Name"
        required
      >
        <el-input
          v-model="collection.name"
          type="text"
          placeholder="Name"
          @focus="form.errors.clear('name')"
          v-input-focus
        ></el-input>
      </el-form-item>

      <el-form-item
        :error="
          form.errors.first('description')
            ? form.errors.first('description')
            : null
        "
        label="Description"
      >
        <el-input
          v-model="collection.description"
          type="textarea"
          placeholder="Description"
          :autosize="{ minRows: 2, maxRows: 4 }"
          @focus="form.errors.clear('description')"
        ></el-input>
      </el-form-item>

      <el-form-item label="Settings">
        <el-checkbox v-model="collection.fileable"> Files </el-checkbox>
        <el-checkbox v-model="collection.linkable"> Links </el-checkbox>
        <el-checkbox v-model="collection.orderable"> Orderable </el-checkbox>
        <el-checkbox v-model="collection.downloadable">
          Downloadable
        </el-checkbox>
      </el-form-item>

      <el-form-item
        :error="
          form.errors.first('mime_types')
            ? form.errors.first('mime_types')
            : null
        "
        label="File Types"
        v-if="collection.fileable"
      >
        <modal-select>
          <el-select
            v-model="collection.mime_types"
            :style="{ width: '100%' }"
            multiple
            clearable
            placeholder="Assign Allowed File Types..."
            @focus="form.errors.clear('mime_types')"
          >
            <el-option-group
              v-for="group in mimes"
              :key="group.group"
              :label="group.group"
            >
              <el-option
                v-for="item in group.mimes"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-option-group>
          </el-select>
        </modal-select>
      </el-form-item>

      <el-button
        type="primary"
        plain
        medium
        native-type="submit"
        :style="{ width: '100%' }"
        v-loading="loading"
      >
        Update
      </el-button>
    </el-form>
  </el-card>
</template>


<script>
import Form from "form-backend-validation"
import { mapActions, mapGetters } from "vuex"

export default {
  name: "CollectionEditForm",

  mixins: [],

  props: {
    existing: {
      required: true,
    },
  },
  data() {
    return {
      collection: {},
      form: new Form(),
      loading: false,
      defaultCollectionWarning:
        "This is a default collection. Modifying a default collection could result " +
        "in unexpected behaviors. You may want to create a new collection. Otherwise, proceed with caution!",
    }
  },
  computed: {
    ...mapGetters({
      mimes: "collections/mimes",
    }),
  },

  methods: {
    ...mapActions({
      updateCollection: "collections/update",
    }),
    update() {
      this.loading = true

      let formData = {
        name: this.collection.name,
        description: this.collection.description,
        fileable: this.collection.fileable,
        linkable: this.collection.linkable,
        orderable: this.collection.orderable,
        downloadable: this.collection.downloadable,
        mime_types: this.collection.mime_types,
      }

      this.axios
        .post("collections/update/" + this.collection.slug, formData)
        .then((response) => {
          this.updateCollection(response.data.data)
          this.$modal.hide("collection-edit-form")
          this.$message.success(response.data.message)
          this.loading = false
        })
        .catch((resp) => {
          this.loading = false
          if (resp.response && resp.response.status === 422) {
            this.form.onFail(resp)
          } else {
            this.$root.globalRequestError(resp)
          }
        })
    },
  },

  created() {
    this.collection = this.$_.cloneDeep(this.existing)
    if (this.collection.mime_types !== null) {
      this.collection.fileable = true
    } else {
      this.collection.fileable = false
    }
  },
}
</script>
